import { render, staticRenderFns } from "./Traffic.vue?vue&type=template&id=2d83908a&scoped=true"
import script from "./Traffic.vue?vue&type=script&lang=js"
export * from "./Traffic.vue?vue&type=script&lang=js"
import style0 from "./Traffic.vue?vue&type=style&index=0&id=2d83908a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d83908a",
  null
  
)

export default component.exports